<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
    <div class="container-xl">
      <div class="row g-4 mb-4">
        <div class="col">
          <div class="alert alert-danger mt40">
            <div>
              <h4>Page not found</h4>
              <p>Go to <RouterLink :to="{name: 'Index'}">Home</RouterLink></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {
  errorMessage,
  isError,
  isLoading,
} from "@/inc/storage";

export default {
  name: "NotFoundPage",
  data() {
    return {}
  },
  setup() {
    return {
      isLoading, isError, errorMessage
    }
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>